import { Injectable } from '@angular/core';

@Injectable()
export class LogoutService {

  constructor () { }

  logout (iframe: any) {  
    var win;
    try {
        win = iframe.contentWindow;
    } catch(e) {
        win = iframe.contentWindow;
    }
    iframe.contentWindow.postMessage(JSON.stringify({key: 'chave_sistema', method: "remove"}), "*");
    localStorage.clear();
    sessionStorage.clear();
  }

}
